<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('clearance.clearance')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link to="/clearance">
                                        {{ trans('clearance.clearance') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ trans('clearance.create_clearance') }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/clearance')"><i class="feather icon-list"></i> {{trans('clearance.clearance_list')}}</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{trans('clearance.create_clearance')}}</h4>
                </div>

                <div class="card-content">
                    <div class="card-body">
                        <form @submit.prevent="proceed" @keydown="clearanceForm.errors.clear($event.target.name)">
                            <div class="row">
                                <div class="col-xl-7 col-md-12 col-12">
                                    <div class="form-group">
                                        <label for="">MDA</label>
                                        <v-select :options="mdas" :reduce="name => name.id" label="name" :class="{ 'form-control is-invalid': clearanceForm.errors.has('mda_id') }" name="mda_id" v-model="clearanceForm.mda_id"></v-select>
                                        <show-error :form-name="clearanceForm" prop-name="mda_id"></show-error>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-12 col-12">
                                    <div class="form-group">
                                        <label for="">Month</label>
                                        <select class="form-control" :class="{ 'is-invalid': clearanceForm.errors.has('month') }" name="month" v-model="clearanceForm.month">
                                            <option value="1">January</option>
                                            <option value="2">February</option>
                                            <option value="3">March</option>
                                            <option value="4">April</option>
                                            <option value="5">May</option>
                                            <option value="6">June</option>
                                            <option value="7">July</option>
                                            <option value="8">August</option>
                                            <option value="9">September</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                        </select>
                                        <show-error :form-name="clearanceForm" prop-name="month"></show-error>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-md-12 col-12">
                                    <div class="form-group">
                                        <label for="">{{trans('payment.year')}}</label>
                                        <select class="form-control" :class="{ 'is-invalid': clearanceForm.errors.has('year') }" name="year" v-model="clearanceForm.year">
                                            <option value="">Select</option>
                                            <option v-for="year in years()" :value="year">{{year}}</option>
                                        </select>
                                        <show-error :form-name="clearanceForm" prop-name="year"></show-error>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="row">
                                <div class="col-md-8 offset-md-4">
                                    <button-spinner
                                        :is-loading="clearanceForm.isLoading" 
                                        :disabled="clearanceForm.isLoading"
                                        
                                        class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                                        style="height: 39px; color: #fff;"
                                        >
                                        <span v-if="id">{{trans('general.update')}}</span>
                                        <span v-else>{{trans('general.save')}}</span>
                                    </button-spinner>

                                    <router-link to="/payment" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1">{{trans('general.cancel')}}
                                    </router-link>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                clearanceForm: new Form({
                    isLoading: false,
                    id: '',
                    mda_id: '',
                    year: new Date().getFullYear(),
                    month: '',
                    
                }),
                mdas: [],
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getPayment();
            this.fetchPreRequisites();
        },
        methods: {
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.mdas = response.mdas;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            proceed(){
                if(this.id)
                    this.updatePayment();
                else
                    this.storePayment();
            },
            storePayment(){
                this.clearanceForm.isLoading = true;
                this.clearanceForm.post('/api/clearance')
                    .then(response => {
                        this.clearanceForm.isLoading = false;
                        toastr.success(response.message);
                        this.$router.push('/clearance');
                    })
                    .catch(error => {
                        this.clearanceForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            },
            
            updatePayment(){
                this.clearanceForm.isLoading = true;
                this.clearanceForm.patch('/api/celarance/'+this.id)
                    .then(response => {
                        this.clearanceForm.isLoading = false;
                        toastr.success(response.message);
                        this.$router.push('/clearance');
                    })
                    .catch(error => {
                        this.clearanceForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            },
            
            years(){
                let years = [];
                for (let index = 0; index < 5; index++) {
                    years.push(moment().subtract(index, 'year').format('YYYY'));
                    
                }
                return years;
            }
        }
    }
</script>
